import styles from './IconTextUnit.module.scss';

export interface IconTextUnitProps {
  text: string;
  imgSrc?: string;
  unit?: string;
  textSize?: 'default' | 'xLarge';
  isUnitBold?: boolean;
  'data-testid'?: string;
}

function IconTextUnit({
  text,
  imgSrc,
  unit,
  textSize = 'default',
  isUnitBold = false,
  'data-testid': dataTestId,
}: IconTextUnitProps) {
  return (
    <div className={`${styles.componentStyle} ${styles[`${textSize}Text`]}`} data-testid={dataTestId}>
      {imgSrc && (
        <div className={styles.icon}>
          <img src={imgSrc} alt='' />
        </div>
      )}
      <div className={styles.iconUnitContainer}>
        <p className={styles.text}>{text}</p>
        {unit && <span className={`${styles.unit} ${isUnitBold ? styles.boldUnit : ''}`}>{unit}</span>}
      </div>
    </div>
  );
}

export default IconTextUnit;
